export const APP_VERSION = "1.0.0";
export const BUILD_ID = "1.0.0-1785617880036";
export const BUILD_GENERATED_AT = "2026-08-01T20:58:00.036Z";
